import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Field,
  FieldArray,
  reduxForm,
  stopSubmit,
  formValueSelector,
  getFormValues,
  formValues,
} from 'redux-form';
import DealSubcatagoryDropdown from './components/DealSubcatagoryDropdown';
import {
  Form,
  FormGroup,
  Button,
  Label,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
} from 'reactstrap';
import { withRouter } from 'react-router';
import TextInput from '../../system/fields/TextInput';
import FileUpload from '../../system/fields/FileUpload';
import List from '../../system/fields/List';
import * as validations from '../../system/utils/Validation';

import OptionsWrapper from './components/Options';

import DatesWrapper from './components/Dates';
import SelectDropdown from '../../system/fields/SelectDropdown';
import Wysiwyg from '../../system/fields/Wysiwyg';
import Switch from '../../system/fields/Switch';

import { getOverview } from '../../store/overview';

import ReviewsTable from './components/ReviewsTable';
import OptionTabs from './components/OptionTabs';
import DealNewCruiseLineWrapper from './components/DealNewCruiseLineWrapper';
class renderDates extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    dateType: 'SingleMonth',
  };

  render() {
    const { props } = this;
    const {
      day_dates,
      fields,
      meta: { touched, error },
      airports,
      options,
      deal_id,
    } = props;

    console.log(props, 'Otpinsis!!!!!!!!!');
    return (
      <div className='repeater-container'>
        <div className='add-button top'>
          {fields.length === 0 && (
            <Button
              type='button'
              onClick={() => {
                fields.push({
                  dates: options.map((each) => ({
                    deal_id: deal_id,
                    option_id: each.id,
                    option: each,
                  })),
                });
              }}
            >
              Add Date
            </Button>
          )}
          <Button
            type='button'
            color='danger'
            className='float-right'
            onClick={() => fields.removeAll()}
          >
            Clear Dates
          </Button>
        </div>

        {/* {fields.map((date, index) => { */}
        {/* return ( */}
        <DatesWrapper
          // date={date}
          fields={fields}
          // index={index}
          //key={index}
          airports={airports}
          dispatch={this.props.dispatch}
          dateType={'month'}
        />
        {/* ); */}
        {/* })} */}
      </div>
    );
  }
}

const renderOptions = ({ fields, meta: { touched, error, index } }) => (
  <div className='repeater-container pb-5 mb-5'>
    <div className='add-button bottom' style={{ marginBottom: '25px' }}>
      <Button type='button' onClick={() => fields.push({ name: '' })}>
        Add Option
      </Button>
    </div>
    <OptionTabs fields={fields} OIindex={index} />
    {/* {fields.map((option, index) => (
      <OptionsWrapper
        option={option}
        fields={fields}
        index={index}
        key={index}
      />
    ))} */}
  </div>
);

class EditForm extends Component {
   constructor() {
    super();

    this.toggleCruiseLine = this.toggleCruiseLine.bind(this);
  }
  state = {
    activeTab: 1,
    selectedTopLevelCategories: [],
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggleCruiseLine() {
    this.setState({
      cruiseLineToggle: !this.state.cruiseLineToggle,
    });
  }

  componentDidMount() {
    this.props.dispatch(getOverview());
    if (this.props.initialValues !== undefined) {
      this.setState({
        subCatagories: this.props.initialValues.top_level_categories,
      });
    }
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.formValues) {
      //this.moveMap(nextProps.position)
    }
  };
  render() {
    const { handleSubmit, initialValues, regions } = this.props;

    const {
      deposit,
      duration,
      name,
      price_from,
      redirect_url,
      sub_title,
      trip_advisor_script,
    } = initialValues || {}

    return (
      <section className='edit-form'>
        <Form onSubmit={handleSubmit}>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 1 ? 'active' : ''}
                onClick={() => {
                  this.toggleTab(1);
                }}
              >
                Basic Info
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 2 ? 'active' : ''}
                onClick={() => {
                  this.toggleTab(2);
                }}
              >
                Options
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={this.state.activeTab === 3 ? 'active' : ''}
                onClick={() => {
                  this.toggleTab(3);
                }}
              >
                Dates
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 4 ? 'active' : ''}
                onClick={() => {
                  this.toggleTab(4);
                }}
              >
                Reviews
              </NavLink>
            </NavItem>
          </Nav>
          <section className='form-section'>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId={1}>
                <div className='row'>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label>Deal Status</Label>
                    <Field
                      name='deal_status'
                      component={SelectDropdown}
                      labelKey='name'
                      valueKey='id'
                      options={this.props.dealStatuses}
                      validate={validations.required}
                      autoFocus={true}
                    />
                  </FormGroup>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label>Search Tags</Label>
                    <Field
                      name='search_tags'
                      component={SelectDropdown}
                      labelKey='value'
                      valueKey='id'
                      options={this.props.searchTags}
                      autoFocus={true}
                      multi
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  {/* {console.log(this.props.subCategories, 'hello big deano')} */}
                  <FormGroup className='col-12 col-sm-6'>
                    <Label>Deal Category</Label>
                    <Field
                      name='top_level_categories'
                      onChange={(value) =>
                        this.setState({ subCatagories: value })
                      }
                      component={SelectDropdown}
                      labelKey='name'
                      valueKey='id'
                      options={this.props.destinationCategories}
                      // validate={validations.required}
                      autoFocus={true}
                      multi
                    />
                  </FormGroup>
                  {console.log(this.state.subCatagories, 'subcatagories',this.props.formValues)}
                  <FormGroup className='col-12 col-sm-6'>
                    <Label>Deal Sub-Cagegory</Label>
                    {this.props.formValues &&
                      this.props.formValues.top_level_categories && (
                        <DealSubcatagoryDropdown
                          // validate={validations.required}
                          formValues={this.props.formValues}
                          SubCatagories={this.props.subCategories}
                          DealCatagory={
                            this.props.formValues
                              ? this.props.formValues.top_level_categories
                              : []
                          }
                        />
                      )}
                  </FormGroup>
                </div>
                {console.log(this.props.destinationCategories)}
                <div className='row'>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label htmlFor='email'>Deal Name</Label>
                    <Field
                      name='name'
                      component={TextInput}
                      placeholder='Deal Name'
                      type='text'
                      defaultValue={name > 0 && name || ''}
                      validate={validations.required}
                    />
                  </FormGroup>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label htmlFor='email'>Sub Title</Label>
                    <Field
                      name='sub_title'
                      component={TextInput}
                      placeholder='Sub Title'
                      type='text'
                      defaultValue={sub_title > 0 && sub_title || ''}
                      validate={validations.required}
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label>Tags</Label>
                    <Field
                      name='deal_types'
                      component={SelectDropdown}
                      options={this.props.dealTypes}
                      type='text'
                      labelKey={'name'}
                      valueKey={'id'}
                      // validate={validations.required}
                      multi
                    />
                  </FormGroup>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label>Bookable Online</Label>
                    <Field name='book_online' component={Switch} type='text' />
                  </FormGroup>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label>Book With Confidence</Label>
                    <Field
                      name='peace_of_mind'
                      component={Switch}
                      type='text'
                    />
                  </FormGroup>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label htmlFor='email'>Deal Duration</Label>
                    <Field
                      name='duration'
                      component={TextInput}
                      placeholder='Deal Duration'
                      type='number'
                      defaultValue={duration > 0  && duration  || ''}
                      validate={validations.required}
                    />
                  </FormGroup>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label htmlFor='email'>Price From</Label>
                    <Field
                      name='price_from'
                      component={TextInput}
                      placeholder='Price From'
                      type='text'
                      defaultValue={price_from > 0 && price_from  || ''}
                      validate={validations.required}
                    />
                  </FormGroup>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label htmlFor='deposit'>Deposit</Label>
                    <Field
                      name='deposit'
                      component={TextInput}
                      placeholder='0'
                      type='number'
                      defaultValue={deposit  > 0  && deposit  || ''}
                    />
                  </FormGroup>
                </div>
                <div className='row'>
                      <FormGroup className='col-12 col-sm-4'>
                        <Label>Cruise Line Name</Label>
                        <Field
                          name='cruise_line'
                          component={SelectDropdown}
                          options={this.props.cruiseLines}
                          labelKey={'name'}
                          valueKey={'id'}
                          type='text'
                          multi={false}
                          className='form-control'
                        // validate={validations.required}
                        />
                            <Modal
                            isOpen={this.state.cruiseLineToggle}
                            toggle={this.toggleCruiseLine}
                            >
                                <ModalBody>
                                    <DealNewCruiseLineWrapper regions={regions} />
                                </ModalBody>
                            </Modal>
                    </FormGroup>
                </div>
                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label htmlFor='email'>Hero Image</Label>
                    <p className='instruction'>
                      Images must be 1920 x 1080 or bigger in the same aspect
                      ratio
                    </p>
                    <Field
                      name='banner_image'
                      component={FileUpload}
                      multiple={false}
                      files={false}
                      images={true}
                      type='text'
                      className='form-control'
                      validate={validations.required}
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label htmlFor='email'>Summary</Label>
                    <Field
                      name='summary'
                      component={Wysiwyg}
                      placeholder='Summary'
                      type='text'
                      validate={validations.required}
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label htmlFor='email'>Fine Print</Label>
                    <Field
                      name='fine_print'
                      component={Wysiwyg}
                      placeholder='Fine Print'
                      type='text'
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label htmlFor='email'>Exclusions</Label>
                    <Field
                      name='exclusions'
                      component={Wysiwyg}
                      placeholder='Exclusions'
                      type='text'
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label htmlFor='email'>Trip Advisor Script</Label>
                    <Field
                      name='trip_advisor_script'
                      component={TextInput}
                      placeholder='Trip Advisor Script'
                      type='text'
                      defaultValue={trip_advisor_script > 0 && trip_advisor_script  || '' }
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label htmlFor='email'>Redirect URL</Label>
                    <Field
                      name='redirect_url'
                      component={TextInput}
                      placeholder='Redirection URL'
                      type='text'
                      defaultValue={redirect_url && redirect_url  || ''}
                    />
                  </FormGroup>
                </div>
              </TabPane>

              <TabPane tabId={2}>
                <FieldArray name='options' component={renderOptions} />
              </TabPane>

              <TabPane tabId={3}>
                <FieldArray
                  name='month_dates'
                  day_dates={this.props.day_dates}
                  component={renderDates}
                  options={this.props.options}
                  deal_id={this.props.match.params.id}
                  dateType={this.props.dateType}
                  dispatch={this.props.dispatch}
                  airports={this.props.airports}
                  disableAddNewDate={this.props.disableAddNewDate}
                  addNewDate={this.props.addNewDate}
                />
              </TabPane>
              <TabPane tabId={4}>
                <ReviewsTable
                  data={this.props.reviews}
                  dispatch={this.props.dispatch}
                  formValues={this.props.formValues}
                  initialValues={this.props.initialValues}
                  formType='DealForm'
                />
              </TabPane>
            </TabContent>
          </section>
        </Form>

        {this.props.submitFailed && (
          <div className='error-container'>
            <Alert color='danger'>
              <strong>There are errors in your form.</strong>
              <br />
              Please check before submitting again.
            </Alert>
          </div>
        )}
      </section>
    );
  }
}

EditForm = reduxForm({
  form: 'DealForm',
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit('DealForm'));
    }
  },
  destroyOnUnmount: false,
})(EditForm);

const selector = formValueSelector('DealForm');

const mapStateToProps = (state) => {
  return {
    dealTypes: state.overview.dealTypes,
    airports: state.overview.airports,
    dealStatuses: state.overview.dealStatuses,
    destinationCategories: state.overview.destinationCategories,
    subCategories: state.overview.subCategories,
    reviews: state.overview.reviews,
    day_dates: selector(state, 'day_dates'),
    formValues: getFormValues('DealForm')(state),
    searchTags: state.overview.searchTags,
    options: selector(state, 'options'),
  };
};

export default withRouter(connect(mapStateToProps)(EditForm));



// WEBPACK FOOTER //
// ./src/containers/Deals/Form.jsx